import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const TrackerCtx = createContext(null);
export const useTracker = () => useContext(TrackerCtx);
const KEY = "hattrick_tracked";

export function TrackerProvider({ children }) {
  const [tracked, setTracked] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(tracked)); }, [tracked]);

  const id = (t) => `${t.team}-${t.jersey}-${t.position}`;
  const isTracked = useCallback((t) => tracked.some((x) => x.id === id(t)), [tracked]);
  const toggle = useCallback((t) => {
    const _id = id(t);
    setTracked((cur) => cur.some((x) => x.id === _id)
      ? cur.filter((x) => x.id !== _id)
      : [...cur, { id: _id, jersey: t.jersey, name: t.name, position: t.position, line: t.line,
                   pp_unit: t.pp_unit, team: t.team, opponent: t.opponent, opp_ga_gp: t.opp_ga_gp,
                   goalie_name: t.goalie_name, goalie_ga: t.goalie_ga }]);
  }, []);
  const remove = useCallback((_id) => setTracked((cur) => cur.filter((x) => x.id !== _id)), []);
  const clear = useCallback(() => setTracked([]), []);

  return (
    <TrackerCtx.Provider value={{ tracked, isTracked, toggle, remove, clear }}>
      {children}
    </TrackerCtx.Provider>
  );
}
